import { apiGet } from 'APIPackage/MainModule/common/apiTools';

interface IFetchAddresses {
  query: string;
}

export async function fetchAddresses({ query }: IFetchAddresses): Promise<string[]> {
  const queryParams = new URLSearchParams();

  if (query) {
    queryParams.append('address', query);
  }

  return apiGet<string[]>(`/address/api/search-full?${queryParams}`);
}
